import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {UserSlice} from "@/lib/types/finsey/user";
import UserService from "@/services/Nest/user.service";
import ApplicationService from "@/services/Bubble/finsey/ApplicationService";

const initialState: UserSlice = {
    user: {
        id: '',
        name: '',
        idCard: '',
        email: '',
        phoneNumber: ''
    },
    applications: [],
    isReApply: false,
    auth: {
        isFetching: true,
        isLoggedIn: false,
        isRetry: false,
        triggerFetch: true,
    }
};

export const userSlice = createSlice({
    name: "user",
    initialState,
    reducers: {
        setUser: (state, actions: PayloadAction<any>) => {
            state.user = actions.payload;
        },
        setApplication: (state, actions: PayloadAction<any>) => {
            state.applications = actions.payload;
        },
        setAuth:(state, actions: PayloadAction<{ isFetching?: boolean, isLoggedIn?: boolean, isRetry?: boolean, triggerFetch?: boolean }>) => {
            if(actions.payload.triggerFetch == false || actions.payload.triggerFetch == true){
                state.auth.triggerFetch = actions.payload.triggerFetch;
            }
            if(actions.payload.isFetching == false || actions.payload.isFetching == true){
                state.auth.isFetching = actions.payload.isFetching;
            }
            if(actions.payload.isLoggedIn == false || actions.payload.isLoggedIn == true){
                state.auth.isLoggedIn = actions.payload.isLoggedIn;
            }
            if(actions.payload.isRetry == false || actions.payload.isRetry == true){
                state.auth.isRetry = actions.payload.isRetry;
            }
        },
        resetAuth(state){
            state.user.id = '';
            state.user.email = '';
            state.user.name = '';
            state.user.phoneNumber = '';
            state.applications = [];
            state.auth.isFetching = false;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchUserData.fulfilled, (state, action) => {
                state.user = action.payload.user
                state.applications = action.payload.applications
                state.isReApply = action.payload.isReApply
                state.auth.isFetching = false
            })
            .addCase(fetchUserData.pending, (state, action) => {
                state.auth.isFetching = true;
            })
            .addCase(fetchUserData.rejected, (state, action) => {
                state.user.id = '';
                state.user.email = '';
                state.user.name = '';
                state.user.phoneNumber = '';
                state.applications = [];
                state.auth.isFetching = false
            })
    }
});

export const fetchUserData = createAsyncThunk(
    "auth/fetchUserData",
    async (data, thunkAPI) => {
        try {
            const userService = new UserService()
            const applicationService = new ApplicationService()
            const user: any = await userService.getInfo()
            const {applications} = await applicationService.getApplicationByEmail(user.email)
            return {user, applications}
        } catch (error: any) {
            return error;
        }
    }
);


export const { setUser, setAuth,setApplication ,resetAuth} = userSlice.actions;
export default userSlice;
